var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          true
            ? _c(
                "v-btn",
                {
                  attrs: { small: "", flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.reset()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("settings_backup_restore")
                  ]),
                  _vm._v(
                    "\n            " + _vm._s(_vm.$t("cancel")) + "\n          "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "two-line": "", dense: "" } },
            [
              _c(
                "draggable",
                {
                  attrs: { options: _vm.options },
                  on: {
                    change: function($event) {
                      return _vm.writecookie()
                    }
                  },
                  model: {
                    value: _vm.items,
                    callback: function($$v) {
                      _vm.items = $$v
                    },
                    expression: "items"
                  }
                },
                [
                  _c(
                    "transition-group",
                    { attrs: { name: "slide-x-transition" } },
                    _vm._l(_vm.items, function(item, i) {
                      return _c(
                        "v-list-tile",
                        { key: item.title },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-checkbox", {
                                attrs: { slot: "activator" },
                                on: {
                                  change: function($event) {
                                    return _vm.writecookie()
                                  }
                                },
                                slot: "activator",
                                model: {
                                  value: item.show,
                                  callback: function($$v) {
                                    _vm.$set(item, "show", $$v)
                                  },
                                  expression: "item.show"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("cap")(
                                      _vm.$tc(item.title, 2, { count: "" })
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          false
                            ? _c(
                                "v-list-tile-action",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { staticClass: "mr-2" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { small: "", icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.down(i)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "red" } },
                                                [_vm._v("arrow_downward")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { staticClass: "mr-2" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { small: "", icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.up(i)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "green" } },
                                                [_vm._v("arrow_upward")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "drag-handle",
                                              attrs: { small: "", icon: "" }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("drag_indicator")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-618160e2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618160e2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzChooseLayoutFicheVisiteur.vue
// module id = null
// module chunks = 